var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":_vm.title}},[_c('div',{staticClass:"pie-chart-withdraw"},[_c('withdraw-main-chart',{attrs:{"title":_vm.title,"data":_vm.dataVisualization}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }